import { inject, observer } from "mobx-react";
import redirectTo from "../../../utils/redirectTo";
import { CREATED_STATUSES } from "../constants";
import styles from "./styles.module.scss";
import SouvenirStore from "../../../stores/SouvenirStore";

export const SouvenirController = ({
  status,
  donationsStatus,
  souvenirs,
  getSouvenirs,
  cancelRequest,
  userEmail,
  error,
}: {
  status: 'auth' | 'no_request' | 'created' | 'in_progress' | 'sent' | 'received' | 'declined',
  donationsStatus,
  souvenirs,
  getSouvenirs,
  cancelRequest,
  userEmail,
  error
}) => {
  const getButtonText = () => {
    switch (status) {
      case 'auth':
        return 'Зарегистрироваться';
      case 'no_request':
        return 'Получить доступные сувениры';
      case 'declined':
        return 'Получить доступные сувениры';
      case 'received':
        return 'Получить доступные сувениры';

      default:
        return 'Заявка успешно принята!';
    }
  };

  const getInfoText = () => {
    if (!donationsStatus.hasConfirmedDonationsAfterReg && !donationsStatus.hasDonationsInThisYear) {
      return <p>У вас нет <a href="/profile/add_donation">донаций</a> после регистрации в системе</p>;
    } else if (donationsStatus.hasConfirmedDonationsAfterReg && !donationsStatus.hasDonationsInThisYear) {
      return <p>У вас нет совершенных <a href="/profile/add_donation">донаций</a> в 2025 году</p>;
    } else if (!donationsStatus.hasConfirmedDonationsAfterReg && donationsStatus.hasDonationsInThisYear) {
      return <p>У вас нет <a href="/profile/add_donation">донаций</a> после регистрации в системе</p>;
    } else if (donationsStatus.hasConfirmedDonationsAfterReg && donationsStatus.hasDonationsInThisYear && cantTake()) {
      return <p>У вас недостаточное количество <a href="/profile/add_donation">донаций</a></p>;
    } else if (!donationsStatus.hasConfirmedEmail) {
      return <p>У вас нет <a href="/profile/settings/general/">подтвержденной почты</a></p>;
    } else if (donationsStatus.hasEmailInSendsayStoplist) {
      return <p>Подпишитесь на <a href="/profile?inactive_email=true" target="_blank">емайл-рассылку</a>, только так мы сможем прислать вам инструкцию, как получить сувенир. Подписка активируется в течении часа. Если возникла проблема, напишите нам в службу поддержки: <a href="mailto:support@donorsearch.org">support@donorsearch.org</a>.</p>;
    } else if (!donationsStatus.hasConfirmedPhone) {
      return <p>У вас нет <a href="/profile/settings/general/">подтвержденного номера телефона</a></p>;
    } else {
      return false;
    }
  }

  const handleClick = () => {
    if (status === 'auth') {
      redirectTo('/login?next=/souvenir')
    } else if (!cantTake() && !getInfoText()) {
      getSouvenirs()
    }
  };

  const cantTake = () => {
    if (['no_request', 'declined', 'received'].includes(status)) {
      for (const key in souvenirs) {
        const item = souvenirs[key];
        if (!item.received && item.progress >= item.progress_limit) {
          return false;
        }
      }
      return true;
    }
    return false;
  }

  return (
    <div className={styles.SouvenirController}>

      <button
        type="button"
        className={`
          ${styles.SouvenirController_button} 
          ${((CREATED_STATUSES.includes(status) || cantTake() || getInfoText()) && status !== 'auth') && styles.disabled}
          ${status === 'created' && styles.WithoutMarginBottom}
        `}
        onClick={() => handleClick()}
      >
        {getButtonText()}
      </button>

      {
        error && <p className={styles.Error}>{error}</p>
      }

      {
        status === 'created' &&
        <p className={styles.CanselReq} onClick={() => cancelRequest()}>Отменить заявку</p>
      }

      {
        (status !== 'auth' && getInfoText()) &&
        <p className={styles.SouvenirController_donationsStatusText}>{getInfoText()}</p>
      }

      {
        status === 'no_request' &&
        <div className={styles.SouvenirController_getInfo}>
          <p>☝️ Убедитесь, что телефон и email в вашем профиле актуальны. Инструкцию отправим на почту, а уведомление о доставке — по телефону. Если вы не читаете почту или отписаны от рассылки, а телефон недействителен, то уведомление получить не сможете.</p>
          <p>☝️ Благодаря вам мы сможем поддержать ещё больше доноров. Вы можете оформить разовую или ежемесячную подписку на <a href="/donate?utm_source=souvenir&utm_medium=ds&utm_campaign=donor_search">проект</a>.</p>
        </div>
      }

      {
        CREATED_STATUSES.includes(status) &&
        <div className={styles.SouvenirController_disabled}>
          <p>В течение 30 дней на вашу почту (<b>{userEmail ? userEmail : 'Укажите вашу почту в настройках профиля!'}</b>) придёт письмо с инструкцией как получить сувениры DonorSearch. Проверяйте папку спам или рассылки, наши письма могут оказаться там. Вы можете отменить текущий запрос — например, если хотите запросить сразу несколько сувениров вместе, напишите на <a href="mailto:support@donorsearch.org">support@donorsearch.org</a>. Второй раз в течение года заказать сувенир не получится.</p>
        </div>
      }

    </div>
  );
};
